import { For, Portal, Show } from "solid-js/web";
import { $confirm_dialogs } from "../store";
import { splitProps } from "solid-js";
import { Atom } from ":mods";

export function ConfirmDialog() {
  const clickOutsideEvent$ = Atom.Directive.method.clickOutsideEvent$;

  function removeDialog(index: number) {
    $confirm_dialogs.set((s) => {
      s.splice(index, 1);
      return [...s];
    });
  }
  return (
    <Portal>
      <Show when={$confirm_dialogs.value.length > 0}>
        <main class={`!absolute bottom-0 !z-99 flex flex-col !items-center !justify-center w-full h-full bg-black/30`}>
          <For each={$confirm_dialogs.value}>
            {(props, index) => {
              const [local, other] = splitProps(props, ["title", "message", "events"]);
              return (
                //? outer container
                <section
                  use:clickOutsideEvent$={() => {
                    removeDialog(index());
                    local.events?.onCancelled?.();
                  }}
                  class={`
                  !z-10 !my-1
                  px-2 py-3 w-35% h-fit
                  flex flex-col bottom-0 self-center !items-center !justify-center  
                  transition-all duration-300 ease-in-out
                  `}
                >
                  {/* inner container */}
                  <section
                    class={`text-1rem
                      !z-50 flex flex-col w-full h-full justify-between !self-center overflow-hidden rounded-lg 
                      bg#paper text#p
                      px-2 py-1
                      `}
                  >
                    <div class="!sticky !top-0 flex flex-row justify-between items-center border-b border-solid border#p bg#paper bg#p">
                      <h1 class="text-1em">{local.title ?? "TITLE"}</h1>
                    </div>
                    <div class="flex flex-row items-center space-x-2 text-0.8em mb-5 mt-3">
                      {local.message ?? "MESSAGE"}
                    </div>
                    {/* <div class="flex flex-col w-full h-full overflow-auto">{local.element}</div> */}
                    <div class="flex flex-row capitalize textmd items-center justify-center space-x-2 children:(!w-30%  capitalize rounded-lg text-md)">
                      <button
                        class="form-btn bg!pt text!p"
                        onClick={() => {
                          removeDialog(index());
                          local.events?.onCancelled?.();
                        }}
                      >
                        cancel
                      </button>
                      <button
                        class="form-btn "
                        onClick={() => {
                          removeDialog(index());
                          local.events?.onConfirmed?.();
                        }}
                      >
                        confirm
                      </button>
                    </div>
                  </section>
                </section>
              );
            }}
          </For>
        </main>
      </Show>
    </Portal>
  );
}
